import { selectHelplyAccountId } from 'ducks/accounts/selectors/selectHelplyAccountId'
import {
  selectPrefersAiEnabled,
  selectPrefersHelplyCopilotEnabled,
} from 'selectors/app/selectAccountPreferences'

// Whether the Helply Copilot panel should be available for this account.
// Requires AI features enabled AND a linked Helply account (Helply can't serve
// Copilot without one), then respects the account-level opt-out pref
// (helply_copilot_enabled). Billing entitlement is layered on separately later.

export const selectHasHelplyCopilotAddon = state => {
  if (!selectPrefersAiEnabled(state)) return false
  if (!selectHelplyAccountId(state)) return false

  return !!selectPrefersHelplyCopilotEnabled(state)
}
